export const headerMenu = () => {

    const burgerBtn = document.querySelector(".js-burger-open");
    const headerMenu = document.querySelector(".header__menu");
    const hederBurger = document.querySelector(".header__burger");
    const headerFixed = document.querySelector(".header__fixed");
    const headerOutLinks = document.querySelector(".header__outlinks");
  
    burgerBtn?.addEventListener("click", function(){
        
      headerMenu.classList.toggle("header__menu_open");
      hederBurger.classList.toggle("header__burger_open");
      headerOutLinks.classList.toggle("header__outlinks_open");
  
    });







    window.addEventListener("scroll", () => {
      if ( window.pageYOffset > 67 ){
        headerFixed?.classList.add("header__fixed_stick");
      } else {
        headerFixed?.classList.remove("header__fixed_stick");
      }
    });
  
  }